<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitcancelData()" [disabled]="!validflag">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm(false)" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3">
                    <label>Id</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Id"
                      (input)="numCheck('Id')" placeholder="Enter Id">
                    <div class="err" id="Id_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Name</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Name"
                      (input)="blankCheck('Name')" placeholder="Enter Name">
                    <div class="err" id="Name_err" style="height:30px"></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view Details -->
<div [hidden]="!viewpage" class="tdive">
  <div *ngIf="actionmode == 'view'" class="searchdiv">
    <div class="card screen-wrapper">
      <div style="border-bottom:1px solid #ddd9d9;margin-bottom: 15px; ">
        <h4 class="screen-title">{{ screentitle }}</h4>
        <div class="button-wrapper bothbuttdiv2">

          <button style="margin-top: 8px" class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <table aria-describedby="insuranceProviderData" class="viewtable">
      <div *ngFor="let q of EditData">
        <tr>
          <th scope="col"><span class="vlbl"> Id </span></th>
          <td><span class="vVal">{{ q.map_id }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Name</span></th>
          <td><span class="vVal">{{ q.value }}</span></td>
        </tr>

      </div>
    </table>
  </div>
</div>
<!-- End -->
<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Insurance Provider</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                    <table aria-describedby="insuranceMasterSearchData" class="table table-striped" [mfData]="searchtabledata" [mfRowsOnPage]="5">
                      <tr>
                        <th scope="col" style="width: 7%">Action
                        </th>
                        <th scope="col"> Id</th>
                        <th scope="col"> Name </th>
                      </tr>
                      <tr *ngFor="let q of (searchtabledata
                        | paginate: { itemsPerPage: 10, currentPage: p })">
                        <td>
                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,1)">
                            <em class="fa fa-eye"></em>
                          </button>

                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,2)">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </td>

                        <td>
                          <span class="vVal">{{ q.map_id }}</span>
                        </td>

                        <td>
                          <span class="vVal">{{ q.value }}</span>
                        </td>
                      </tr>
                      <tfoot>
                        <tr>
                          <td colspan="4">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>